import styled from 'styled-components';

import { PatientPregnant } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

type GynecologicalInterviewPatientPrednantEntryCellProps = {
   readonly patientPregnantInterview: PatientPregnant;
};

const StyledGynecologicalInterviewPatientPregnantEntryCell = styled.div`
   text-transform: lowercase;
   &:first-letter {
      text-transform: uppercase;
   }
`;
StyledGynecologicalInterviewPatientPregnantEntryCell.displayName =
   'StyledGynecologicalInterviewPatientPregnantEntryCell';

export const GynecologicalInterviewPatientPregnantEntryCell = (
   props: GynecologicalInterviewPatientPrednantEntryCellProps
): JSX.Element => {
   return (
      <StyledGynecologicalInterviewPatientPregnantEntryCell>
         <Translate>{gynecologicalInterviewTranslationKeys.interviewType.PATIENT_PREGNANT}</Translate>
         {', '}
         <Translate>
            {props.patientPregnantInterview.pregnancyConfirmed
               ? gynecologicalInterviewTranslationKeys.pregnancyConfirmed
               : gynecologicalInterviewTranslationKeys.pregnancyUnconfirmed}
         </Translate>
         {props.patientPregnantInterview.multiplePregnancy ? (
            <>
               {', '}
               <Translate>{gynecologicalInterviewTranslationKeys.multiplePregnancy}</Translate>
            </>
         ) : null}
         {props.patientPregnantInterview.predictedCompletionDate ? (
            <>
               {', '}
               <Translate>{gynecologicalInterviewTranslationKeys.predictedCompletionDate}</Translate>
               {': '}
               {dateFormatter(props.patientPregnantInterview.predictedCompletionDate)}
            </>
         ) : null}
         {props.patientPregnantInterview.predictedCompletionBasis ? (
            <>
               {', '}
               <Translate>{gynecologicalInterviewTranslationKeys.determinedOnBasis}</Translate>
               {': '}
               <Translate>
                  {
                     gynecologicalInterviewTranslationKeys.predictedCompletionDateBasis[
                        props.patientPregnantInterview.predictedCompletionBasis
                     ]
                  }
               </Translate>
            </>
         ) : null}
      </StyledGynecologicalInterviewPatientPregnantEntryCell>
   );
};
